import {ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy} from '@angular/core';
import {FormService} from 'app/core/services/form.service';

@Component({
    selector: 'form-errors',
    templateUrl: './form-errors.component.html',
    styleUrls: ['./form-errors.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorsComponent implements OnDestroy {
    @HostBinding('class.on-top')
    @Input()
    top = true;

    @HostBinding('class.on-bottom')
    get onBottom() {
        return !this.top;
    }

    constructor(public formService: FormService) {}

    ngOnDestroy() {
        this.formService.clearErrors();
    }
}
